import React from 'react';
import { T, fontBody, selectStyle } from '../../tokens';
import { TRIGGER_LIBRARY_MAP } from '../../utils/flowUtils';
import Field from '../Field';
import ToggleRow from '../../ToggleRow';

const FLOW_TRIGGER_OPTIONS = [
  { libraryId: 'ig-comment', label: 'Instagram Comment' },
  { libraryId: 'ig-dm', label: 'Instagram DM' },
  { libraryId: 'fb-comment', label: 'Facebook Comment' },
  { libraryId: 'messenger', label: 'Facebook Messenger' },
];

export default function AutomationMetaEditor({
  name,
  triggerLibraryId,
  status,
  createLead,
  isChannelDefault,
  onNameChange,
  onTriggerLibraryChange,
  onStatusChange,
  onCreateLeadChange,
  onIsChannelDefaultChange,
  errors = {},
  isNew,
}) {
  const selectedId = triggerLibraryId || 'ig-comment';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {(isNew || name !== undefined) && (
        <Field label="Automation name">
          <input
            value={name || ''}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="e.g. PMAY Campaign"
            style={{ ...selectStyle, borderColor: errors.name ? '#DC2626' : T.line }}
          />
          {errors.name && <div style={{ fontSize: 11, color: '#DC2626', marginTop: 4 }}>{errors.name}</div>}
        </Field>
      )}

      <Field label="Trigger source">
        <select
          style={selectStyle}
          value={selectedId}
          onChange={(e) => onTriggerLibraryChange(e.target.value)}
        >
          {FLOW_TRIGGER_OPTIONS.map((opt) => (
            <option key={opt.libraryId} value={opt.libraryId}>{opt.label}</option>
          ))}
        </select>
        <div style={{ fontFamily: fontBody, fontSize: 11, color: T.slateLight, marginTop: 6 }}>
          Sets the first step — {TRIGGER_LIBRARY_MAP[selectedId]?.label}
        </div>
      </Field>

      {onIsChannelDefaultChange && (
        <div>
          <ToggleRow
            label="Set as default for this channel"
            checked={!!isChannelDefault}
            onChange={onIsChannelDefaultChange}
          />
          {isChannelDefault && (
            <div style={{
              marginTop: 6, padding: '6px 10px', borderRadius: 7,
              background: '#F0FDF4', border: '1px solid #BBF7D0',
              fontFamily: fontBody, fontSize: 11, color: '#15803D', lineHeight: 1.45,
            }}
            >
              This flow fires when no keyword template matches for this channel.
              Only one template can be the default per channel — enabling this will clear the previous default.
            </div>
          )}
        </div>
      )}

      <ToggleRow
        label={status === 'Active' ? 'Automation active' : 'Automation paused'}
        checked={status === 'Active'}
        onChange={(on) => onStatusChange(on ? 'Active' : 'Paused')}
      />

      {onCreateLeadChange && (
        <ToggleRow
          label="Create CRM lead on trigger"
          checked={!!createLead}
          onChange={onCreateLeadChange}
        />
      )}
    </div>
  );
}
